var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForestreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 52.0003C0 47.5819 3.58186 44 8.00032 44C12.4188 44 16.0006 47.5819 16.0006 52.0003C16.0006 56.4187 12.4188 60.0006 8.00032 60.0006C3.58186 60.0006 0 56.4187 0 52.0003Z",
    fill: "#2E71E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.0003C0 25.5819 3.58186 22 8.00032 22H25.001C29.4194 22 33.0013 25.5819 33.0013 30.0003C33.0013 34.4187 29.4194 38.0006 25.001 38.0006H8.00032C3.58186 38.0006 0 34.4187 0 30.0003Z",
    fill: "#2E71E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00032C0 3.58186 3.58186 0 8.00032 0H42.0017C46.4201 0 50.002 3.58186 50.002 8.00032C50.002 12.4188 46.4201 16.0006 42.0017 16.0006H8.00032C3.58186 16.0006 0 12.4188 0 8.00032Z",
    fill: "#2E71E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestreet);
export default __webpack_public_path__ + "static/media/Forestreet.9b8d88eddd35cd450cafb8180a339a81.svg";
export { ForwardRef as ReactComponent };